export const QUERYSTRING_FILTERS = [
  'zones',
  'surrounding',
  'numRooms',
  'numBaths',
  'numParkingSpaces',
  'garden',
  'balcony',
  'terrace',
  'level',
  'lift',
  'heatingType',
  'availability',
  'buildingCondition',
  'energyClass',
  'sellerType',
  'publication_date',
  'photo',
  'has_virtual_tour',
];

export const FILTERS_TO_EXCLUDE_FROM_DISPLAY_COUNT = [
  'channel',
  'category',
  'surrounding',
  'priceType',
  'mortgage',
  'oldcategory',
  'propertyTypes',
  'license_type_groups',
];

export const NO_BUY_PTYPEGROUPS = [
  'stanze',
];

export const filterSectionNames = {
  category: 'Cerco',
  channel: 'in',
  price: 'Prezzo',
  price_rent: 'Canone affitto',
  mq: 'Metri quadri',
  rooms: 'Locali',
  baths: 'Bagni',
  numParkingSpaces: 'Box / posti Auto',
  level: 'Piano',
  lift: 'Ascensore',
  heatingType: 'Riscaldamento',
  garden: 'Giardino',
  balcony: 'Balcone / terrazzo',
  energyClass: 'Classe energetica',
  buildingCondition: 'Condizione immobile',
  buildingYear: 'Anno di costruzione',
  availability: 'Stato al rogito',
  sellerType: 'Tipo di inserzionista',
  furniture: 'Arredamento',
  air_conditioned: 'Aria condizionata',
  publication_date: 'Data di pubblicazione',
  exclude_under_construction: 'Case in costruzione',
  is_lux: 'Immobili di prestigio',
  is_auction: 'Aste',
  has_swimming_pool: 'Piscina',
  has_reception: 'Portineria',
  has_virtual_tour: 'Visita guidata da casa',
  balconyAndTerrace: 'Balcone / terrazzo',
  includes_property_ownership: 'Con o senza mura',
  commercial_building_location: 'Posizione',
};

export const filterSectionNamesForSeoLinks = {
  price: 'Prezzo',
  mq: 'Metri quadri',
  rooms: 'Locali',
  baths: 'Bagni',
  numParkingSpaces: 'Box / posti Auto',
  level: 'Piano',
  lift: 'Ascensore',
  heatingType: 'Riscaldamento',
  garden: 'Giardino',
  balcony: 'Balcone',
  terrace: 'Terrazzo',
  energyClass: 'Classe energetica',
  buildingCondition: 'Condizione immobile',
  buildingYear: 'Anno di costruzione',
  availability: 'Stato al rogito',
  sellerType: 'Annunci da',
  furniture: 'Arredamento',
  air_conditioned: 'Aria condizionata',
  publication_date: 'Data di pubblicazione',
  is_lux: 'Immobili di prestigio',
  exclude_under_construction: 'Case pronte e in costruzione',
  is_auction: 'Aste',
  has_swimming_pool: 'Case con o senza piscina',
  has_reception: 'Case con o senza portineria',
  has_virtual_tour: 'Visita live da casa',
  includes_property_ownership: 'Con o senza mura',
};
